import React, { useState } from "react";
import { Container, Row, Col, Card, CardBody, Modal, Label, Input, Button } from "reactstrap";

// Formik Validation
import { withRouter, useHistory } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";

// actions
import "../../assets/scss/custom/style.css";

import moment from 'moment';
import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';


const Portfolio = props => {
  //meta title
  document.title = "User Portfolio";
  const history = useHistory();
  const { getRequest, postRequest } = useRequests();


  const [AlertData, setAlertData] = React.useState({
		variant: '',
		message: '',
	});
	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData((AlertData) => ({
				...AlertData,
				variant: '',
				message: '',
			}));
		}, 5000);
	};


  const [ UserInfo, setUserInfo ] = React.useState([]);
  const handleLoadGetUserInfo = async () => {
    const jsonpar = JSON.stringify({
      u_id: atob(props.match.params.id)
    });
    const res = await postRequest('get-user-info', jsonpar);
    if (res && res.code === 200) {
      setUserInfo(res.data);
    }
    else {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }

  const [TotalInvestment, setTotalInvestment] = React.useState({
		total_value: 0,
    total_value_token_price: 0
	});
  const [TransactionTBody, setTransactionTBody] = React.useState('');
  const handleT1Body = async (tempData) => {
    let tempTBody = tempData.map((element, index) => (
      <tr key={index}>
        <td>{element.hash.slice(0, 12)}...</td>
        <td>{moment.unix(element.time_stamp).format('YYYY-MM-DD | HH:mm')}</td>
        <td>{element.value}</td>
        <td>{parseFloat(element.value) * parseFloat(element.token_price)} EUR </td>
        <td>{element.lock_in_period_no} {element.lock_in_period_no > 1? element.lock_in_period + 's' : element.lock_in_period}</td>
        <td>{element.is_claimed === 1? 'Yes' : 'No'}</td>
      </tr>
    ));

    setTransactionTBody(tempTBody);
  }
  const handleLoadGetPropertyInvestment = async () => {
    const jsonpar = JSON.stringify({
      u_id: atob(props.match.params.id)
    });
    const res = await postRequest('get-user-property-investment', jsonpar);
    if (res && res.code === 200) {
      handleT1Body(res.data.crypto_transaction);

      setTotalInvestment({
        ...TotalInvestment,
        total_value: res.data.total_value,
        total_value_token_price: res.data.total_value_token_price
      });
    }
    else {
      let tempTBody = (<tr>
                        <td colSpan="5" className="text-center">No records found</td>
                      </tr>);

      setTransactionTBody(tempTBody);
    }
  }
  React.useEffect(() => {
    if (!props.match.params.id) {
      history.push({
        pathname: '/user_management',
        state: { code: 401, status: 'error', message: 'ID not found! Please provide a valid ID.' }
      });
		}
    else {
      handleLoadGetUserInfo();
      handleLoadGetPropertyInvestment();
    }
  }, []);


  return (
    <React.Fragment>
			{AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content common-width">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title="Eshepay" breadcrumbItem="User Portfolio" />
          <Row>
            <Col xs="12">
              <Row>
                <Col lg="12">
                  <Card>
                    <CardBody>
                      <div className="d-flex mobileFullWidth">
                        <div className="flex-grow-1 align-self-center">
                          <div className="text-muted">
                            <h5>User Investment : {UserInfo.first_name} {UserInfo.last_name} ( {UserInfo.email} )</h5>
                            <p className="mb-1">{TotalInvestment.total_value} Tokens ({TotalInvestment.total_value_token_price} EUR)</p>
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                  <Card>
                    <CardBody>
                      <div className="table-responsive">
                        <table className="table mb-0" style={{ minWidth: '1000px' }}>
                          <thead className="table-light">
                            <tr>
                              <th>Transaction Hash</th>
                              <th>Date</th>
                              <th>Tokens</th>
                              <th>Current Token Value</th>
                              <th>Lock-In Period</th>
                              <th>Claimed</th>
                            </tr>
                          </thead>
                          <tbody>
                            {TransactionTBody}
                          </tbody>
                        </table>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>

    </React.Fragment>
  );
};

export default withRouter(Portfolio);
